import { Route, Routes, useNavigate, useLocation  } from "react-router-dom";
import Layout from "./layout/Layout";
import Dispositivi from "./pages/Dispositivi/Dispositivi";
import Settings from "./pages/Settings";
import Dashboard from "./pages/Dashboard/Dashboard";
import CallLogs from "./pages/CallLogs/CallLogs";
import Users from "./pages/Users/Users";
import ErrorPage from "./pages/ErrorPage";
import Logout from "./pages/Logout";
import Login from "./pages/Login/Login";
import { useSelector, useDispatch } from "react-redux";
import {policies} from "./const/policies"
import Interceptor from "./helpers/Interceptor";
import { refreshToken } from "./redux/reducers/user-reducer";


let permessi = [];


function App() {
  const location = useLocation();

  const userDate = localStorage.getItem('calldetector');

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const state = useSelector((state) => state.userDate);
  
  if (JSON.stringify(state) === '{}' && location.pathname != '/') {
    const objUserDate = JSON.parse(userDate)
    dispatch(refreshToken(objUserDate, navigate));    
  }

  state.policies != undefined ? permessi = state.policies : permessi = [];

  Interceptor(dispatch);
  
  return (
    <Layout>
      <Routes>
                                  {/*aggiungi i path anche nella pageError'pageListAvailable' */}
              {permessi.indexOf(policies.dashboardVisualizzazione) != -1 && <Route path="/dashboard" element={<Dashboard />} /> }
              {permessi.indexOf(policies.chiamataVisualizzazione) != -1 &&<Route path="/logs" element={<CallLogs />} /> }
              {permessi.indexOf(policies.utentiVisualizzazione) != -1 &&<Route path="/utenti" element={<Users />} /> }
              {permessi.indexOf(policies.dispositiviVisualizzazione) != -1 &&<Route path="/dispositivi" element={<Dispositivi />} /> }
              {state.token !== undefined && <Route path="/settings" element={<Settings />} /> }
              <Route path="/logout" element={<Logout />} />
              <Route path="/" element={<Login />} />
              <Route path="*" element={<ErrorPage />} />
      </Routes>
    </Layout>
  );
}


export default App;
